import axios from "axios";
import firebase from "firebase/compat/app";

const korpodeskApi = {
  async request(endpoint, method = "GET", data = null, customHeaders = {}, responseType = "json") {
    console.log("📡 Korpodesk API Request:", { endpoint, method, data });

    try {
      // 🔥 Dynamische Base URL abhängig von der aktuellen Domain
      let baseUrl;
      if (window.location.hostname.includes("korpodesk.de")) {
        baseUrl = "https://us-central1-korpodesk.cloudfunctions.net";
      } else if (window.location.hostname.includes("localhost")) {
        baseUrl = "https://us-central1-korpodesk.cloudfunctions.net";
      } else {
        console.error("❌ API Fehler: Falsche baseUrl");
        return {
          data: null,
          error: "❌ API Fehler: Falsche baseUrl",
        };
      }

      const jwtToken = await firebase.auth.currentUser.getIdToken(); // Falls Auth erforderlich

      // 🏷 Automatisch `x-organization` aus der aktuellen URL ermitteln
      // const organization = window.location.hostname.split(".")[0]; // "rbo" aus "rbo.korpodesk.de"

      // map rbo ->

      const config = {
        method,
        url: `${baseUrl}${endpoint}`,
        headers: {
          Authorization: jwtToken ? `Bearer ${jwtToken}` : "", // Falls kein Token vorhanden, wird er weggelassen
          "Content-Type": "application/json",
          "x-organization": "rbo.v2.korpodesk.de" || "default", // Fallback zu "default"
          ...customHeaders, // Zusätzliche Header
        },
        data,
        responseType,
      };

      const response = await axios(config);

      if (responseType === "blob") {
        return { data: response.data, error: null }; // Datei-Download oder Blob zurückgeben
      }
      console.log("📡 Korpodesk API Response:", response.data);
      if (response.data.success) {
        return {
          data: response.data.data,
          success: response.data.success,
          error: null,
        };
      } else {
        console.warn("⚠ API Warning:", response);
        throw new Error(response.data.message || "Unbekannter Fehler.");
      }
    } catch (error) {
      console.error("❌ API Fehler:", error);
      return {
        data: null,
        error: error.response.data || error.message,
      };
    }
  },
};

export default korpodeskApi;



// WEBPACK FOOTER //
// ./src/services/korpodeskApi.js